import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { useFieldWrapper } from '@/components/shared/components/NewContextForms/FieldWrapperContext';
import {
  CustomSelectField,
  CustomSelectFieldExtraProps,
} from '@/components/shared/components/NewContextForms/shared/CustomSelectField';
import { CustomTextFieldProps } from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { ReadOnlyDataRow } from '@/components/shared/components/NewContextForms/shared/ReadOnlyDataRow';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export interface SelectFormFieldProps<TFieldValues extends FieldValues>
  extends CustomTextFieldProps<TFieldValues>,
    CustomSelectFieldExtraProps {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

export function SelectFormField<T extends FieldValues>({
  name,
  dummyField = false,
  ...props
}: SelectFormFieldProps<T>) {
  const formControl = useFormContext()?.control;
  const wrapField = useFieldWrapper();

  if (!formControl || dummyField)
    return props.fieldVariant === FieldVariant.form ? (
      <CustomSelectField disabled={true} {...props} />
    ) : (
      <ReadOnlyDataRow {...props} />
    );

  return wrapField(
    name,
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomSelectField fieldVariant={FieldVariant.form} {...props} field={field} error={error} />
      )}
    />,
  );
}
